import firebase from "firebase/app";
import "firebase/analytics";

import { getLocationSettings } from "./location";
import { logInfo } from "common/debug-print";

export function builderFirebaseAnalyticsMeasure(): string {
    return getLocationSettings().measurementID;
}

export function initFirebase(): void {
    logInfo("initing firebase");

    // Sometimes multiple instances are created of this class,
    // but we can only initialize firebase once.
    if (firebase.apps.length > 0) return;
    firebase.initializeApp(getLocationSettings().firebaseConfig);
}
